import { React } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useGetLogsQuery } from "state/api";
import { useAuth } from "../../contexts/AuthContext";
import moment from "moment";

const GridDash = () => {
  const { user, isLoading: authLoading } = useAuth();
  const { data, isLoading, isFetching } = useGetLogsQuery(
    { start: 0, size: 10, filters: [], globalFilter: "", sorting: [] },
    { skip: !user, refetchOnFocus: true, refetchOnReconnect: true }
  );

  return (
    <DataGrid
      autoPageSize
      loading={authLoading || isLoading || isFetching}
      rows={data?.logs ?? []}
      getRowId={(row) => row._id ?? row.id}
      columns={[
        {
          field: "searchDate",
          sortable: false,
          filterable: false,
          headerName: "Search Date",
          width: 190,
          renderCell: (params) =>
            moment(params.row.searchDate).format("DD-MM-YYYY"),
        },
        {
          field: "name",
          sortable: false,
          filterable: false,
          headerName: "Name Searched",
          width: 190,
        },
        {
          field: "status",
          sortable: false,
          filterable: false,
          headerName: "Status",
          width: 190,
        },
        {
          field: "type",
          headerName: "Type",
          sortable: false,
          width: 200,
          filterable: false,
          valueGetter: (params) => params.row.criteria?.typ,
          renderCell: (params) => params.value,
        },
      ]}
    />
  );
};

export default GridDash;
